import { Navigate, useParams } from "react-router-dom";

import AICareerBuddy from "../AICareerBuddy";
import Announcement from "../Announcement";
import CareerSkills from "../../CareerSkills";
import ChatwithAi from "../ChatwithAi.jsx";
import Council from "../Council";
import Dashboard from "../Dashboard";
import KnowTheProcess from "../HowItWorks";
import LeaderTraits from "../LeaderTraits";
import Milestone from "../Milestone";
import PortalFeedbackForm from "../Feedback";
import Profile from "../Profile";
import Reports from "../Reports";
import ParentAssessmentPage from "./ParentAssessmentPage";
import ParentChildAccess from "./ParentChildAccess";

const SECTION_COMPONENTS = {
  dashboard: Dashboard,
  assessment: ParentAssessmentPage,
  reports: Reports,
  "career-skills": CareerSkills,
  council: Council,
  counseling: Council,
  milestone: Milestone,
  chatbot: ChatwithAi,
  chatbuddy: AICareerBuddy,
  announcement: Announcement,
  feedback: PortalFeedbackForm,
  "how-it-works": KnowTheProcess,
  dna: LeaderTraits,
  profile: Profile,
};

const ParentPortalPage = () => {
  const { section } = useParams();
  const activeSection = section || "dashboard";
  const SectionComponent = SECTION_COMPONENTS[activeSection];

  if (!SectionComponent) {
    return <Navigate to="/parent-portal/dashboard" replace />;
  }

  if (["reports", "career-skills", "council", "counseling", "milestone"].includes(activeSection)) {
    return (
      <ParentChildAccess
        render={({ selectedChild, selector }) => (
          <SectionComponent
            parentMode
            studentUserId={selectedChild.id}
            studentName={selectedChild.name || "Student"}
            childSelector={selector}
          />
        )}
      />
    );
  }

  return <SectionComponent />;
};

export default ParentPortalPage;
